module.exports = __webpack_public_path__ + "assets/redpack-progress-bg-e46227bc.png";